module.exports = __webpack_public_path__ + "font_banana.3c24d540.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/font_banana.png
// module id = 6D5P
// module chunks = 0